import { useState, useEffect } from "react";
import { Loader2, Download } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResourceViewer() {
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const pathParts = window.location.pathname.split("/");
    const id = pathParts[pathParts.length - 1];
    if (!id) { setError("Resource not found."); setLoading(false); return; }

    const fetchResource = async () => {
      try {
        const res = await axios.get(`${API}/resource/${id}`);
        setResource(res.data);
      } catch (err) {
        setError("Resource not found or unavailable.");
      } finally {
        setLoading(false);
      }
    };
    fetchResource();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-slate-400 animate-spin" />
      </div>
    );
  }

  if (error || !resource) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-slate-400 text-lg">{error || "Resource not found."}</p>
        </div>
      </div>
    );
  }

  const streamUrl = `${API}/resource/${resource.id}/stream`;

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        {/* Header */}
        <div className="flex justify-center mb-6">
          <img src="/zkteco-logo.png" alt="ZKTeco" className="h-10 w-auto opacity-80" />
        </div>

        {/* Video Player */}
        <div className="bg-black rounded-xl overflow-hidden shadow-2xl mb-6" data-testid="resource-player">
          <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
            <video
              controls
              playsInline
              preload="metadata"
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              data-testid="resource-video"
            >
              <source src={streamUrl} type={resource.content_type || "video/mp4"} />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Info */}
        <div className="text-center">
          <h1 className="text-xl sm:text-2xl font-bold text-white mb-2" data-testid="resource-title">
            {resource.title}
          </h1>
          <span className="inline-block bg-slate-800 text-slate-300 text-xs font-medium px-3 py-1 rounded-full mb-3">
            {resource.category}
          </span>
          {resource.description && (
            <p className="text-sm text-slate-400 max-w-2xl mx-auto mt-2">{resource.description}</p>
          )}
          <a href={`${API}/resource/${resource.id}/download`} download className="inline-block mt-4">
            <button className="inline-flex items-center gap-1.5 bg-slate-800 hover:bg-slate-700 text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
              <Download className="h-4 w-4" /> Download Video
            </button>
          </a>
        </div>

        {/* Footer */}
        <div className="text-center mt-10">
          <p className="text-xs text-slate-600">ZKTeco UK Solution Configurator</p>
        </div>
      </div>
    </div>
  );
}
